module.exports = __webpack_public_path__ + "static/img/OC_bg02.a5dab23.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/runtime/components/assets/OC_bg02.png
// module id = hx1k
// module chunks = 7